module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"cloudSettings":"Cloud settings","name":{"label":"Name","required":"Please enter card name"},"cloudUpdated":"Cloud has been updated successfully"},"ru":{"cloudSettings":"Настройки облака","name":{"label":"Название","required":"Пожалуйста, введите название облака"},"cloudUpdated":"Облако успешно обновлено"}}')
  delete Component.options._Ctor
}
